function qt(y) {
  return y && y.__esModule && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y;
}
var xe, We;
function Yt() {
  if (We) return xe;
  We = 1;
  function y(e) {
    return e instanceof Map ? e.clear = e.delete = e.set = function() {
      throw new Error("map is read-only");
    } : e instanceof Set && (e.add = e.clear = e.delete = function() {
      throw new Error("set is read-only");
    }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((t) => {
      const s = e[t], p = typeof s;
      (p === "object" || p === "function") && !Object.isFrozen(s) && y(s);
    }), e;
  }
  class h {
    /**
     * @param {CompiledMode} mode
     */
    constructor(t) {
      t.data === void 0 && (t.data = {}), this.data = t.data, this.isMatchIgnored = !1;
    }
    ignoreMatch() {
      this.isMatchIgnored = !0;
    }
  }
  function S(e) {
    return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
  }
  function E(e, ...t) {
    const s = /* @__PURE__ */ Object.create(null);
    for (const p in e)
      s[p] = e[p];
    return t.forEach(function(p) {
      for (const _ in p)
        s[_] = p[_];
    }), /** @type {T} */
    s;
  }
  const P = "</span>", $ = (e) => !!e.scope, q = (e, { prefix: t }) => {
    if (e.startsWith("language:"))
      return e.replace("language:", "language-");
    if (e.includes(".")) {
      const s = e.split(".");
      return [
        `${t}${s.shift()}`,
        ...s.map((p, _) => `${p}${"_".repeat(_ + 1)}`)
      ].join(" ");
    }
    return `${t}${e}`;
  };
  class Y {
    /**
     * Creates a new HTMLRenderer
     *
     * @param {Tree} parseTree - the parse tree (must support `walk` API)
     * @param {{classPrefix: string}} options
     */
    constructor(t, s) {
      this.buffer = "", this.classPrefix = s.classPrefix, t.walk(this);
    }
    /**
     * Adds texts to the output stream
     *
     * @param {string} text */
    addText(t) {
      this.buffer += S(t);
    }
    /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */
    openNode(t) {
      if (!$(t)) return;
      const s = q(
        t.scope,
        { prefix: this.classPrefix }
      );
      this.span(s);
    }
    /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */
    closeNode(t) {
      $(t) && (this.buffer += P);
    }
    /**
     * returns the accumulated buffer
    */
    value() {
      return this.buffer;
    }
    // helpers
    /**
     * Builds a span element
     *
     * @param {string} className */
    span(t) {
      this.buffer += `<span class="${t}">`;
    }
  }
  const x = (e = {}) => {
    const t = { children: [] };
    return Object.assign(t, e), t;
  };
  class v {
    constructor() {
      this.rootNode = x(), this.stack = [this.rootNode];
    }
    get top() {
      return this.stack[this.stack.length - 1];
    }
    get root() {
      return this.rootNode;
    }
    /** @param {Node} node */
    add(t) {
      this.top.children.push(t);
    }
    /** @param {string} scope */
    openNode(t) {
      const s = x({ scope: t });
      this.add(s), this.stack.push(s);
    }
    closeNode() {
      if (this.stack.length > 1)
        return this.stack.pop();
    }
    closeAllNodes() {
      for (; this.closeNode(); ) ;
    }
    toJSON() {
      return JSON.stringify(this.rootNode, null, 4);
    }
    /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */
    walk(t) {
      return this.constructor._walk(t, this.rootNode);
    }
    /**
     * @param {Renderer} builder
     * @param {Node} node
     */
    static _walk(t, s) {
      return typeof s == "string" ? t.addText(s) : s.children && (t.openNode(s), s.children.forEach((p) => this._walk(t, p)), t.closeNode(s)), t;
    }
    /**
     * @param {Node} node
     */
    static _collapse(t) {
      typeof t != "string" && t.children && (t.children.every((s) => typeof s == "string") ? t.children = [t.children.join("")] : t.children.forEach((s) => {
        v._collapse(s);
      }));
    }
  }
  class T extends v {
    /**
     * @param {*} options
     */
    constructor(t) {
      super(), this.options = t;
    }
    /**
     * @param {string} text
     */
    addText(t) {
      t !== "" && this.add(t);
    }
    /** @param {string} scope */
    startScope(t) {
      this.openNode(t);
    }
    endScope() {
      this.closeNode();
    }
    /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */
    __addSublanguage(t, s) {
      const p = t.root;
      s && (p.scope = `language:${s}`), this.add(p);
    }
    toHTML() {
      return new Y(this, this.options).value();
    }
    finalize() {
      return this.closeAllNodes(), !0;
    }
  }
  function N(e) {
    return e ? typeof e == "string" ? e : e.source : null;
  }
  function W(e) {
    return L("(?=", e, ")");
  }
  function j(e) {
    return L("(?:", e, ")*");
  }
  function z(e) {
    return L("(?:", e, ")?");
  }
  function L(...e) {
    return e.map((s) => N(s)).join("");
  }
  function X(e) {
    const t = e[e.length - 1];
    return typeof t == "object" && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
  }
  function pe(...e) {
    return "(" + (X(e).capture ? "" : "?:") + e.map((p) => N(p)).join("|") + ")";
  }
  function we(e) {
    return new RegExp(e.toString() + "|").exec("").length - 1;
  }
  function Xe(e, t) {
    const s = e && e.exec(t);
    return s && s.index === 0;
  }
  const Ke = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
  function ue(e, { joinWith: t }) {
    let s = 0;
    return e.map((p) => {
      s += 1;
      const _ = s;
      let w = N(p), c = "";
      for (; w.length > 0; ) {
        const r = Ke.exec(w);
        if (!r) {
          c += w;
          break;
        }
        c += w.substring(0, r.index), w = w.substring(r.index + r[0].length), r[0][0] === "\\" && r[1] ? c += "\\" + String(Number(r[1]) + _) : (c += r[0], r[0] === "(" && s++);
      }
      return c;
    }).map((p) => `(${p})`).join(t);
  }
  const Fe = /\b\B/, Me = "[a-zA-Z]\\w*", ge = "[a-zA-Z_]\\w*", ke = "\\b\\d+(\\.\\d+)?", Se = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Oe = "\\b(0b[01]+)", qe = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", Ye = (e = {}) => {
    const t = /^#![ ]*\//;
    return e.binary && (e.begin = L(
      t,
      /.*\b/,
      e.binary,
      /\b.*/
    )), E({
      scope: "meta",
      begin: t,
      end: /$/,
      relevance: 0,
      /** @type {ModeCallback} */
      "on:begin": (s, p) => {
        s.index !== 0 && p.ignoreMatch();
      }
    }, e);
  }, Q = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
  }, Ze = {
    scope: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [Q]
  }, Je = {
    scope: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [Q]
  }, Ve = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  }, te = function(e, t, s = {}) {
    const p = E(
      {
        scope: "comment",
        begin: e,
        end: t,
        contains: []
      },
      s
    );
    p.contains.push({
      scope: "doctag",
      // hack to avoid the space from being included. the space is necessary to
      // match here to prevent the plain text rule below from gobbling up doctags
      begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
      end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
      excludeBegin: !0,
      relevance: 0
    });
    const _ = pe(
      // list of common 1 and 2 letter words in English
      "I",
      "a",
      "is",
      "so",
      "us",
      "to",
      "at",
      "if",
      "in",
      "it",
      "on",
      // note: this is not an exhaustive list of contractions, just popular ones
      /[A-Za-z]+['](d|ve|re|ll|t|s|n)/,
      // contractions - can't we'd they're let's, etc
      /[A-Za-z]+[-][a-z]+/,
      // `no-way`, etc.
      /[A-Za-z][a-z]{2,}/
      // allow capitalized words at beginning of sentences
    );
    return p.contains.push(
      {
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: L(
          /[ ]+/,
          // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
          "(",
          _,
          /[.]?[:]?([.][ ]|[ ])/,
          "){3}"
        )
        // look for 3 words in a row
      }
    ), p;
  }, Qe = te("//", "$"), et = te("/\\*", "\\*/"), tt = te("#", "$"), nt = {
    scope: "number",
    begin: ke,
    relevance: 0
  }, st = {
    scope: "number",
    begin: Se,
    relevance: 0
  }, it = {
    scope: "number",
    begin: Oe,
    relevance: 0
  }, rt = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
      Q,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [Q]
      }
    ]
  }, ct = {
    scope: "title",
    begin: Me,
    relevance: 0
  }, ot = {
    scope: "title",
    begin: ge,
    relevance: 0
  }, at = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + ge,
    relevance: 0
  };
  var ne = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: Ze,
    BACKSLASH_ESCAPE: Q,
    BINARY_NUMBER_MODE: it,
    BINARY_NUMBER_RE: Oe,
    COMMENT: te,
    C_BLOCK_COMMENT_MODE: et,
    C_LINE_COMMENT_MODE: Qe,
    C_NUMBER_MODE: st,
    C_NUMBER_RE: Se,
    END_SAME_AS_BEGIN: function(e) {
      return Object.assign(
        e,
        {
          /** @type {ModeCallback} */
          "on:begin": (t, s) => {
            s.data._beginMatch = t[1];
          },
          /** @type {ModeCallback} */
          "on:end": (t, s) => {
            s.data._beginMatch !== t[1] && s.ignoreMatch();
          }
        }
      );
    },
    HASH_COMMENT_MODE: tt,
    IDENT_RE: Me,
    MATCH_NOTHING_RE: Fe,
    METHOD_GUARD: at,
    NUMBER_MODE: nt,
    NUMBER_RE: ke,
    PHRASAL_WORDS_MODE: Ve,
    QUOTE_STRING_MODE: Je,
    REGEXP_MODE: rt,
    RE_STARTERS_RE: qe,
    SHEBANG: Ye,
    TITLE_MODE: ct,
    UNDERSCORE_IDENT_RE: ge,
    UNDERSCORE_TITLE_MODE: ot
  });
  function lt(e, t) {
    e.input[e.index - 1] === "." && t.ignoreMatch();
  }
  function pt(e, t) {
    e.className !== void 0 && (e.scope = e.className, delete e.className);
  }
  function ut(e, t) {
    t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = lt, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
  }
  function gt(e, t) {
    Array.isArray(e.illegal) && (e.illegal = pe(...e.illegal));
  }
  function ft(e, t) {
    if (e.match) {
      if (e.begin || e.end) throw new Error("begin & end are not supported with match");
      e.begin = e.match, delete e.match;
    }
  }
  function ht(e, t) {
    e.relevance === void 0 && (e.relevance = 1);
  }
  const dt = (e, t) => {
    if (!e.beforeMatch) return;
    if (e.starts) throw new Error("beforeMatch cannot be used with starts");
    const s = Object.assign({}, e);
    Object.keys(e).forEach((p) => {
      delete e[p];
    }), e.keywords = s.keywords, e.begin = L(s.beforeMatch, W(s.begin)), e.starts = {
      relevance: 0,
      contains: [
        Object.assign(s, { endsParent: !0 })
      ]
    }, e.relevance = 0, delete s.beforeMatch;
  }, yt = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    // common variable name
    "list",
    // common variable name
    "value"
    // common variable name
  ], mt = "keyword";
  function Re(e, t, s = mt) {
    const p = /* @__PURE__ */ Object.create(null);
    return typeof e == "string" ? _(s, e.split(" ")) : Array.isArray(e) ? _(s, e) : Object.keys(e).forEach(function(w) {
      Object.assign(
        p,
        Re(e[w], t, w)
      );
    }), p;
    function _(w, c) {
      t && (c = c.map((r) => r.toLowerCase())), c.forEach(function(r) {
        const l = r.split("|");
        p[l[0]] = [w, bt(l[0], l[1])];
      });
    }
  }
  function bt(e, t) {
    return t ? Number(t) : Et(e) ? 0 : 1;
  }
  function Et(e) {
    return yt.includes(e.toLowerCase());
  }
  const Ae = {}, K = (e) => {
  }, Ne = (e, ...t) => {
  }, Z = (e, t) => {
    Ae[`${e}/${t}`] || (Ae[`${e}/${t}`] = !0);
  }, se = new Error();
  function ve(e, t, { key: s }) {
    let p = 0;
    const _ = e[s], w = {}, c = {};
    for (let r = 1; r <= t.length; r++)
      c[r + p] = _[r], w[r + p] = !0, p += we(t[r - 1]);
    e[s] = c, e[s]._emit = w, e[s]._multi = !0;
  }
  function xt(e) {
    if (Array.isArray(e.begin)) {
      if (e.skip || e.excludeBegin || e.returnBegin)
        throw K("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), se;
      if (typeof e.beginScope != "object" || e.beginScope === null)
        throw K("beginScope must be object"), se;
      ve(e, e.begin, { key: "beginScope" }), e.begin = ue(e.begin, { joinWith: "" });
    }
  }
  function _t(e) {
    if (Array.isArray(e.end)) {
      if (e.skip || e.excludeEnd || e.returnEnd)
        throw K("skip, excludeEnd, returnEnd not compatible with endScope: {}"), se;
      if (typeof e.endScope != "object" || e.endScope === null)
        throw K("endScope must be object"), se;
      ve(e, e.end, { key: "endScope" }), e.end = ue(e.end, { joinWith: "" });
    }
  }
  function wt(e) {
    e.scope && typeof e.scope == "object" && e.scope !== null && (e.beginScope = e.scope, delete e.scope);
  }
  function Mt(e) {
    wt(e), typeof e.beginScope == "string" && (e.beginScope = { _wrap: e.beginScope }), typeof e.endScope == "string" && (e.endScope = { _wrap: e.endScope }), xt(e), _t(e);
  }
  function kt(e) {
    function t(c, r) {
      return new RegExp(
        N(c),
        "m" + (e.case_insensitive ? "i" : "") + (e.unicodeRegex ? "u" : "") + (r ? "g" : "")
      );
    }
    class s {
      constructor() {
        this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
      }
      // @ts-ignore
      addRule(r, l) {
        l.position = this.position++, this.matchIndexes[this.matchAt] = l, this.regexes.push([l, r]), this.matchAt += we(r) + 1;
      }
      compile() {
        this.regexes.length === 0 && (this.exec = () => null);
        const r = this.regexes.map((l) => l[1]);
        this.matcherRe = t(ue(r, { joinWith: "|" }), !0), this.lastIndex = 0;
      }
      /** @param {string} s */
      exec(r) {
        this.matcherRe.lastIndex = this.lastIndex;
        const l = this.matcherRe.exec(r);
        if (!l)
          return null;
        const O = l.findIndex((ee, he) => he > 0 && ee !== void 0), M = this.matchIndexes[O];
        return l.splice(0, O), Object.assign(l, M);
      }
    }
    class p {
      constructor() {
        this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
      }
      // @ts-ignore
      getMatcher(r) {
        if (this.multiRegexes[r]) return this.multiRegexes[r];
        const l = new s();
        return this.rules.slice(r).forEach(([O, M]) => l.addRule(O, M)), l.compile(), this.multiRegexes[r] = l, l;
      }
      resumingScanAtSamePosition() {
        return this.regexIndex !== 0;
      }
      considerAll() {
        this.regexIndex = 0;
      }
      // @ts-ignore
      addRule(r, l) {
        this.rules.push([r, l]), l.type === "begin" && this.count++;
      }
      /** @param {string} s */
      exec(r) {
        const l = this.getMatcher(this.regexIndex);
        l.lastIndex = this.lastIndex;
        let O = l.exec(r);
        if (this.resumingScanAtSamePosition() && !(O && O.index === this.lastIndex)) {
          const M = this.getMatcher(0);
          M.lastIndex = this.lastIndex + 1, O = M.exec(r);
        }
        return O && (this.regexIndex += O.position + 1, this.regexIndex === this.count && this.considerAll()), O;
      }
    }
    function _(c) {
      const r = new p();
      return c.contains.forEach((l) => r.addRule(l.begin, { rule: l, type: "begin" })), c.terminatorEnd && r.addRule(c.terminatorEnd, { type: "end" }), c.illegal && r.addRule(c.illegal, { type: "illegal" }), r;
    }
    function w(c, r) {
      const l = (
        /** @type CompiledMode */
        c
      );
      if (c.isCompiled) return l;
      [
        pt,
        // do this early so compiler extensions generally don't have to worry about
        // the distinction between match/begin
        ft,
        Mt,
        dt
      ].forEach((M) => M(c, r)), e.compilerExtensions.forEach((M) => M(c, r)), c.__beforeBegin = null, [
        ut,
        // do this later so compiler extensions that come earlier have access to the
        // raw array if they wanted to perhaps manipulate it, etc.
        gt,
        // default to 1 relevance if not specified
        ht
      ].forEach((M) => M(c, r)), c.isCompiled = !0;
      let O = null;
      return typeof c.keywords == "object" && c.keywords.$pattern && (c.keywords = Object.assign({}, c.keywords), O = c.keywords.$pattern, delete c.keywords.$pattern), O = O || /\w+/, c.keywords && (c.keywords = Re(c.keywords, e.case_insensitive)), l.keywordPatternRe = t(O, !0), r && (c.begin || (c.begin = /\B|\b/), l.beginRe = t(l.begin), !c.end && !c.endsWithParent && (c.end = /\B|\b/), c.end && (l.endRe = t(l.end)), l.terminatorEnd = N(l.end) || "", c.endsWithParent && r.terminatorEnd && (l.terminatorEnd += (c.end ? "|" : "") + r.terminatorEnd)), c.illegal && (l.illegalRe = t(
        /** @type {RegExp | string} */
        c.illegal
      )), c.contains || (c.contains = []), c.contains = [].concat(...c.contains.map(function(M) {
        return St(M === "self" ? c : M);
      })), c.contains.forEach(function(M) {
        w(
          /** @type Mode */
          M,
          l
        );
      }), c.starts && w(c.starts, r), l.matcher = _(l), l;
    }
    if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self"))
      throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    return e.classNameAliases = E(e.classNameAliases || {}), w(
      /** @type Mode */
      e
    );
  }
  function Te(e) {
    return e ? e.endsWithParent || Te(e.starts) : !1;
  }
  function St(e) {
    return e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
      return E(e, { variants: null }, t);
    })), e.cachedVariants ? e.cachedVariants : Te(e) ? E(e, { starts: e.starts ? E(e.starts) : null }) : Object.isFrozen(e) ? E(e) : e;
  }
  var Ot = "11.9.0";
  class Rt extends Error {
    constructor(t, s) {
      super(t), this.name = "HTMLInjectionError", this.html = s;
    }
  }
  const fe = S, Le = E, Ie = Symbol("nomatch"), At = 7, je = function(e) {
    const t = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null), p = [];
    let _ = !0;
    const w = "Could not find the language '{}', did you forget to load/include a language module?", c = { disableAutodetect: !0, name: "Plain text", contains: [] };
    let r = {
      ignoreUnescapedHTML: !1,
      throwUnescapedHTML: !1,
      noHighlightRe: /^(no-?highlight)$/i,
      languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
      classPrefix: "hljs-",
      cssSelector: "pre code",
      languages: null,
      // beta configuration options, subject to change, welcome to discuss
      // https://github.com/highlightjs/highlight.js/issues/1086
      __emitter: T
    };
    function l(n) {
      return r.noHighlightRe.test(n);
    }
    function O(n) {
      let a = n.className + " ";
      a += n.parentNode ? n.parentNode.className : "";
      const f = r.languageDetectRe.exec(a);
      if (f) {
        const m = U(f[1]);
        return m || (Ne(w.replace("{}", f[1])), Ne("Falling back to no-highlight mode for this block.", n)), m ? f[1] : "no-highlight";
      }
      return a.split(/\s+/).find((m) => l(m) || U(m));
    }
    function M(n, a, f) {
      let m = "", k = "";
      typeof a == "object" ? (m = n, f = a.ignoreIllegals, k = a.language) : (Z("10.7.0", "highlight(lang, code, ...args) has been deprecated."), Z("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), k = n, m = a), f === void 0 && (f = !0);
      const B = {
        code: m,
        language: k
      };
      re("before:highlight", B);
      const G = B.result ? B.result : ee(B.language, B.code, f);
      return G.code = B.code, re("after:highlight", G), G;
    }
    function ee(n, a, f, m) {
      const k = /* @__PURE__ */ Object.create(null);
      function B(i, o) {
        return i.keywords[o];
      }
      function G() {
        if (!u.keywords) {
          R.addText(b);
          return;
        }
        let i = 0;
        u.keywordPatternRe.lastIndex = 0;
        let o = u.keywordPatternRe.exec(b), g = "";
        for (; o; ) {
          g += b.substring(i, o.index);
          const d = D.case_insensitive ? o[0].toLowerCase() : o[0], A = B(u, d);
          if (A) {
            const [H, Kt] = A;
            if (R.addText(g), g = "", k[d] = (k[d] || 0) + 1, k[d] <= At && (ae += Kt), H.startsWith("_"))
              g += o[0];
            else {
              const Ft = D.classNameAliases[H] || H;
              C(o[0], Ft);
            }
          } else
            g += o[0];
          i = u.keywordPatternRe.lastIndex, o = u.keywordPatternRe.exec(b);
        }
        g += b.substring(i), R.addText(g);
      }
      function ce() {
        if (b === "") return;
        let i = null;
        if (typeof u.subLanguage == "string") {
          if (!t[u.subLanguage]) {
            R.addText(b);
            return;
          }
          i = ee(u.subLanguage, b, !0, $e[u.subLanguage]), $e[u.subLanguage] = /** @type {CompiledMode} */
          i._top;
        } else
          i = de(b, u.subLanguage.length ? u.subLanguage : null);
        u.relevance > 0 && (ae += i.relevance), R.__addSublanguage(i._emitter, i.language);
      }
      function I() {
        u.subLanguage != null ? ce() : G(), b = "";
      }
      function C(i, o) {
        i !== "" && (R.startScope(o), R.addText(i), R.endScope());
      }
      function Pe(i, o) {
        let g = 1;
        const d = o.length - 1;
        for (; g <= d; ) {
          if (!i._emit[g]) {
            g++;
            continue;
          }
          const A = D.classNameAliases[i[g]] || i[g], H = o[g];
          A ? C(H, A) : (b = H, G(), b = ""), g++;
        }
      }
      function He(i, o) {
        return i.scope && typeof i.scope == "string" && R.openNode(D.classNameAliases[i.scope] || i.scope), i.beginScope && (i.beginScope._wrap ? (C(b, D.classNameAliases[i.beginScope._wrap] || i.beginScope._wrap), b = "") : i.beginScope._multi && (Pe(i.beginScope, o), b = "")), u = Object.create(i, { parent: { value: u } }), u;
      }
      function Ue(i, o, g) {
        let d = Xe(i.endRe, g);
        if (d) {
          if (i["on:end"]) {
            const A = new h(i);
            i["on:end"](o, A), A.isMatchIgnored && (d = !1);
          }
          if (d) {
            for (; i.endsParent && i.parent; )
              i = i.parent;
            return i;
          }
        }
        if (i.endsWithParent)
          return Ue(i.parent, o, g);
      }
      function Gt(i) {
        return u.matcher.regexIndex === 0 ? (b += i[0], 1) : (Ee = !0, 0);
      }
      function $t(i) {
        const o = i[0], g = i.rule, d = new h(g), A = [g.__beforeBegin, g["on:begin"]];
        for (const H of A)
          if (H && (H(i, d), d.isMatchIgnored))
            return Gt(o);
        return g.skip ? b += o : (g.excludeBegin && (b += o), I(), !g.returnBegin && !g.excludeBegin && (b = o)), He(g, i), g.returnBegin ? 0 : o.length;
      }
      function Wt(i) {
        const o = i[0], g = a.substring(i.index), d = Ue(u, i, g);
        if (!d)
          return Ie;
        const A = u;
        u.endScope && u.endScope._wrap ? (I(), C(o, u.endScope._wrap)) : u.endScope && u.endScope._multi ? (I(), Pe(u.endScope, i)) : A.skip ? b += o : (A.returnEnd || A.excludeEnd || (b += o), I(), A.excludeEnd && (b = o));
        do
          u.scope && R.closeNode(), !u.skip && !u.subLanguage && (ae += u.relevance), u = u.parent;
        while (u !== d.parent);
        return d.starts && He(d.starts, i), A.returnEnd ? 0 : o.length;
      }
      function zt() {
        const i = [];
        for (let o = u; o !== D; o = o.parent)
          o.scope && i.unshift(o.scope);
        i.forEach((o) => R.openNode(o));
      }
      let oe = {};
      function Ge(i, o) {
        const g = o && o[0];
        if (b += i, g == null)
          return I(), 0;
        if (oe.type === "begin" && o.type === "end" && oe.index === o.index && g === "") {
          if (b += a.slice(o.index, o.index + 1), !_) {
            const d = new Error(`0 width match regex (${n})`);
            throw d.languageName = n, d.badRule = oe.rule, d;
          }
          return 1;
        }
        if (oe = o, o.type === "begin")
          return $t(o);
        if (o.type === "illegal" && !f) {
          const d = new Error('Illegal lexeme "' + g + '" for mode "' + (u.scope || "<unnamed>") + '"');
          throw d.mode = u, d;
        } else if (o.type === "end") {
          const d = Wt(o);
          if (d !== Ie)
            return d;
        }
        if (o.type === "illegal" && g === "")
          return 1;
        if (be > 1e5 && be > o.index * 3)
          throw new Error("potential infinite loop, way more iterations than matches");
        return b += g, g.length;
      }
      const D = U(n);
      if (!D)
        throw K(w.replace("{}", n)), new Error('Unknown language: "' + n + '"');
      const Xt = kt(D);
      let me = "", u = m || Xt;
      const $e = {}, R = new r.__emitter(r);
      zt();
      let b = "", ae = 0, F = 0, be = 0, Ee = !1;
      try {
        if (D.__emitTokens)
          D.__emitTokens(a, R);
        else {
          for (u.matcher.considerAll(); ; ) {
            be++, Ee ? Ee = !1 : u.matcher.considerAll(), u.matcher.lastIndex = F;
            const i = u.matcher.exec(a);
            if (!i) break;
            const o = a.substring(F, i.index), g = Ge(o, i);
            F = i.index + g;
          }
          Ge(a.substring(F));
        }
        return R.finalize(), me = R.toHTML(), {
          language: n,
          value: me,
          relevance: ae,
          illegal: !1,
          _emitter: R,
          _top: u
        };
      } catch (i) {
        if (i.message && i.message.includes("Illegal"))
          return {
            language: n,
            value: fe(a),
            illegal: !0,
            relevance: 0,
            _illegalBy: {
              message: i.message,
              index: F,
              context: a.slice(F - 100, F + 100),
              mode: i.mode,
              resultSoFar: me
            },
            _emitter: R
          };
        if (_)
          return {
            language: n,
            value: fe(a),
            illegal: !1,
            relevance: 0,
            errorRaised: i,
            _emitter: R,
            _top: u
          };
        throw i;
      }
    }
    function he(n) {
      const a = {
        value: fe(n),
        illegal: !1,
        relevance: 0,
        _top: c,
        _emitter: new r.__emitter(r)
      };
      return a._emitter.addText(n), a;
    }
    function de(n, a) {
      a = a || r.languages || Object.keys(t);
      const f = he(n), m = a.filter(U).filter(De).map(
        (I) => ee(I, n, !1)
      );
      m.unshift(f);
      const k = m.sort((I, C) => {
        if (I.relevance !== C.relevance) return C.relevance - I.relevance;
        if (I.language && C.language) {
          if (U(I.language).supersetOf === C.language)
            return 1;
          if (U(C.language).supersetOf === I.language)
            return -1;
        }
        return 0;
      }), [B, G] = k, ce = B;
      return ce.secondBest = G, ce;
    }
    function Nt(n, a, f) {
      const m = a && s[a] || f;
      n.classList.add("hljs"), n.classList.add(`language-${m}`);
    }
    function ye(n) {
      let a = null;
      const f = O(n);
      if (l(f) || (re(
        "before:highlightElement",
        { el: n, language: f }
      ), n.dataset.highlighted))
        return;
      if (n.children.length > 0 && (r.ignoreUnescapedHTML, r.throwUnescapedHTML))
        throw new Rt(
          "One of your code blocks includes unescaped HTML.",
          n.innerHTML
        );
      a = n;
      const m = a.textContent, k = f ? M(m, { language: f, ignoreIllegals: !0 }) : de(m);
      n.innerHTML = k.value, n.dataset.highlighted = "yes", Nt(n, f, k.language), n.result = {
        language: k.language,
        // TODO: remove with version 11.0
        re: k.relevance,
        relevance: k.relevance
      }, k.secondBest && (n.secondBest = {
        language: k.secondBest.language,
        relevance: k.secondBest.relevance
      }), re("after:highlightElement", { el: n, result: k, text: m });
    }
    function vt(n) {
      r = Le(r, n);
    }
    const Tt = () => {
      ie(), Z("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    function Lt() {
      ie(), Z("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let Be = !1;
    function ie() {
      if (document.readyState === "loading") {
        Be = !0;
        return;
      }
      document.querySelectorAll(r.cssSelector).forEach(ye);
    }
    function It() {
      Be && ie();
    }
    typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", It, !1);
    function jt(n, a) {
      let f = null;
      try {
        f = a(e);
      } catch (m) {
        if (K("Language definition for '{}' could not be registered.".replace("{}", n)), _)
          K(m);
        else
          throw m;
        f = c;
      }
      f.name || (f.name = n), t[n] = f, f.rawDefinition = a.bind(null, e), f.aliases && Ce(f.aliases, { languageName: n });
    }
    function Bt(n) {
      delete t[n];
      for (const a of Object.keys(s))
        s[a] === n && delete s[a];
    }
    function Ct() {
      return Object.keys(t);
    }
    function U(n) {
      return n = (n || "").toLowerCase(), t[n] || t[s[n]];
    }
    function Ce(n, { languageName: a }) {
      typeof n == "string" && (n = [n]), n.forEach((f) => {
        s[f.toLowerCase()] = a;
      });
    }
    function De(n) {
      const a = U(n);
      return a && !a.disableAutodetect;
    }
    function Dt(n) {
      n["before:highlightBlock"] && !n["before:highlightElement"] && (n["before:highlightElement"] = (a) => {
        n["before:highlightBlock"](
          Object.assign({ block: a.el }, a)
        );
      }), n["after:highlightBlock"] && !n["after:highlightElement"] && (n["after:highlightElement"] = (a) => {
        n["after:highlightBlock"](
          Object.assign({ block: a.el }, a)
        );
      });
    }
    function Pt(n) {
      Dt(n), p.push(n);
    }
    function Ht(n) {
      const a = p.indexOf(n);
      a !== -1 && p.splice(a, 1);
    }
    function re(n, a) {
      const f = n;
      p.forEach(function(m) {
        m[f] && m[f](a);
      });
    }
    function Ut(n) {
      return Z("10.7.0", "highlightBlock will be removed entirely in v12.0"), Z("10.7.0", "Please use highlightElement now."), ye(n);
    }
    Object.assign(e, {
      highlight: M,
      highlightAuto: de,
      highlightAll: ie,
      highlightElement: ye,
      // TODO: Remove with v12 API
      highlightBlock: Ut,
      configure: vt,
      initHighlighting: Tt,
      initHighlightingOnLoad: Lt,
      registerLanguage: jt,
      unregisterLanguage: Bt,
      listLanguages: Ct,
      getLanguage: U,
      registerAliases: Ce,
      autoDetection: De,
      inherit: Le,
      addPlugin: Pt,
      removePlugin: Ht
    }), e.debugMode = function() {
      _ = !1;
    }, e.safeMode = function() {
      _ = !0;
    }, e.versionString = Ot, e.regex = {
      concat: L,
      lookahead: W,
      either: pe,
      optional: z,
      anyNumberOfTimes: j
    };
    for (const n in ne)
      typeof ne[n] == "object" && y(ne[n]);
    return Object.assign(e, ne), e;
  }, J = je({});
  return J.newInstance = () => je({}), xe = J, J.HighlightJS = J, J.default = J, xe;
}
var Zt = /* @__PURE__ */ Yt();
const Jt = /* @__PURE__ */ qt(Zt), ze = {}, Vt = "hljs-";
function Qt(y) {
  const h = Jt.newInstance();
  return {
    highlight: S,
    highlightAuto: E,
    listLanguages: P,
    register: $,
    registerAlias: q,
    registered: Y
  };
  function S(x, v, T) {
    const N = T || ze, W = typeof N.prefix == "string" ? N.prefix : Vt;
    if (!h.getLanguage(x))
      throw new Error("Unknown language: `" + x + "` is not registered");
    h.configure({ __emitter: en, classPrefix: W });
    const j = (
      /** @type {HighlightResult & {_emitter: HastEmitter}} */
      h.highlight(v, { ignoreIllegals: !0, language: x })
    );
    if (j.errorRaised)
      throw new Error("Could not highlight with `Highlight.js`", {
        cause: j.errorRaised
      });
    const z = j._emitter.root, L = (
      /** @type {RootData} */
      z.data
    );
    return L.language = j.language, L.relevance = j.relevance, z;
  }
  function E(x, v) {
    const N = (v || ze).subset || P();
    let W = -1, j = 0, z;
    for (; ++W < N.length; ) {
      const L = N[W];
      if (!h.getLanguage(L)) continue;
      const X = S(L, x, v);
      X.data && X.data.relevance !== void 0 && X.data.relevance > j && (j = X.data.relevance, z = X);
    }
    return z || {
      type: "root",
      children: [],
      data: { language: void 0, relevance: j }
    };
  }
  function P() {
    return h.listLanguages();
  }
  function $(x, v) {
    if (typeof x == "string")
      h.registerLanguage(x, v);
    else {
      let T;
      for (T in x)
        Object.hasOwn(x, T) && h.registerLanguage(T, x[T]);
    }
  }
  function q(x, v) {
    if (typeof x == "string")
      h.registerAliases(
        // Note: copy needed because hljs doesn’t accept readonly arrays yet.
        typeof v == "string" ? v : [...v],
        { languageName: x }
      );
    else {
      let T;
      for (T in x)
        if (Object.hasOwn(x, T)) {
          const N = x[T];
          h.registerAliases(
            // Note: copy needed because hljs doesn’t accept readonly arrays yet.
            typeof N == "string" ? N : [...N],
            { languageName: T }
          );
        }
    }
  }
  function Y(x) {
    return !!h.getLanguage(x);
  }
}
class en {
  /**
   * @param {Readonly<HljsOptions>} options
   *   Configuration.
   * @returns
   *   Instance.
   */
  constructor(h) {
    this.options = h, this.root = {
      type: "root",
      children: [],
      data: { language: void 0, relevance: 0 }
    }, this.stack = [this.root];
  }
  /**
   * @param {string} value
   *   Text to add.
   * @returns {undefined}
   *   Nothing.
   *
   */
  addText(h) {
    if (h === "") return;
    const S = this.stack[this.stack.length - 1], E = S.children[S.children.length - 1];
    E && E.type === "text" ? E.value += h : S.children.push({ type: "text", value: h });
  }
  /**
   *
   * @param {unknown} rawName
   *   Name to add.
   * @returns {undefined}
   *   Nothing.
   */
  startScope(h) {
    this.openNode(String(h));
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  endScope() {
    this.closeNode();
  }
  /**
   * @param {HastEmitter} other
   *   Other emitter.
   * @param {string} name
   *   Name of the sublanguage.
   * @returns {undefined}
   *   Nothing.
   */
  __addSublanguage(h, S) {
    const E = this.stack[this.stack.length - 1], P = (
      /** @type {Array<ElementContent>} */
      h.root.children
    );
    S ? E.children.push({
      type: "element",
      tagName: "span",
      properties: { className: [S] },
      children: P
    }) : E.children.push(...P);
  }
  /**
   * @param {string} name
   *   Name to add.
   * @returns {undefined}
   *   Nothing.
   */
  openNode(h) {
    const S = this, E = h.split(".").map(function(q, Y) {
      return Y ? q + "_".repeat(Y) : S.options.classPrefix + q;
    }), P = this.stack[this.stack.length - 1], $ = {
      type: "element",
      tagName: "span",
      properties: { className: E },
      children: []
    };
    P.children.push($), this.stack.push($);
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  closeNode() {
    this.stack.pop();
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  finalize() {
  }
  /**
   * @returns {string}
   *   Nothing.
   */
  toHTML() {
    return "";
  }
}
const _e = /* @__PURE__ */ new Map([
  [
    "1c",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./1c-Dyv-oK8h.js")
  ],
  [
    "abnf",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./abnf-D0zrywR6.js")
  ],
  [
    "accesslog",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./accesslog-DL_4w1ag.js")
    )
  ],
  [
    "actionscript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./actionscript-D3WjRklm.js")
    )
  ],
  [
    "ada",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ada-yFj_fJZc.js")
  ],
  [
    "angelscript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./angelscript-WnLMZUIC.js")
    )
  ],
  [
    "apache",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./apache-CzBf6KSz.js")
  ],
  [
    "applescript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./applescript-DJWvL8hS.js")
    )
  ],
  [
    "arcade",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./arcade-TouukGnU.js")
  ],
  [
    "arduino",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./arduino-C1fyd2va.js")
    )
  ],
  [
    "armasm",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./armasm-Bfpm-T6G.js")
  ],
  [
    "asciidoc",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./asciidoc-vcUC1smP.js")
    )
  ],
  [
    "aspectj",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./aspectj-DWrGzmNC.js")
    )
  ],
  [
    "autohotkey",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./autohotkey-CRropRB_.js")
    )
  ],
  [
    "autoit",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./autoit-DgP4Ogut.js")
  ],
  [
    "avrasm",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./avrasm-v2fwUSi0.js")
  ],
  [
    "awk",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./awk-Cl3TLC-3.js")
  ],
  [
    "axapta",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./axapta-CySGEDba.js")
  ],
  [
    "bash",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./bash-D7n8f8ex.js")
  ],
  [
    "basic",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./basic-CEFTPNBZ.js")
  ],
  [
    "bnf",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./bnf-Be_8pf3J.js")
  ],
  [
    "brainfuck",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./brainfuck-CL17nv60.js")
    )
  ],
  // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
  ["c", async () => import("./c-D0W-NFXN.js")],
  [
    "cal",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./cal-DlhpOzII.js")
  ],
  [
    "capnproto",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./capnproto-Bs4AJlgb.js")
    )
  ],
  [
    "ceylon",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ceylon-CYndpJWE.js")
  ],
  [
    "clean",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./clean-D1WAM842.js")
  ],
  [
    "clojure-repl",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./clojure-repl-Bja2E4D_.js")
    )
  ],
  [
    "clojure",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./clojure-aY2138WD.js")
    )
  ],
  [
    "cmake",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./cmake-DjPxFuGG.js")
  ],
  [
    "coffeescript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./coffeescript-QzgZec42.js")
    )
  ],
  [
    "coq",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./coq-CMJAiztk.js")
  ],
  [
    "cos",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./cos-D9oiptkq.js")
  ],
  [
    "cpp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./cpp-vtzuAKx8.js")
  ],
  [
    "crmsh",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./crmsh-D3Cc-hBg.js")
  ],
  [
    "crystal",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./crystal-BtD5fR4q.js")
    )
  ],
  [
    "csharp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./csharp-Cigc7XMa.js")
  ],
  [
    "csp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./csp-pFWifn7Q.js")
  ],
  [
    "css",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./css-B-yPI1XM.js")
  ],
  // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
  ["d", async () => import("./d-OfR4T4RP.js")],
  [
    "dart",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./dart-ogL5qy96.js")
  ],
  [
    "delphi",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./delphi-CcBlKBwb.js")
  ],
  [
    "diff",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./diff-DoNOEpX1.js")
  ],
  [
    "django",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./django-BCjAqpVo.js")
  ],
  [
    "dns",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./dns-CvbXUc4v.js")
  ],
  [
    "dockerfile",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./dockerfile-CbQUuG1i.js")
    )
  ],
  [
    "dos",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./dos-DWndTzZE.js")
  ],
  [
    "dsconfig",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./dsconfig-BLM-dLit.js")
    )
  ],
  [
    "dts",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./dts-DCRhcYCV.js")
  ],
  [
    "dust",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./dust-B_BY3dLS.js")
  ],
  [
    "ebnf",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ebnf-Cwq6G36d.js")
  ],
  [
    "elixir",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./elixir-CauqA_ap.js")
  ],
  [
    "elm",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./elm-Yka1FhON.js")
  ],
  [
    "erb",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./erb-CcmgFbZe.js")
  ],
  [
    "erlang-repl",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./erlang-repl-CFeqjU_T.js")
    )
  ],
  [
    "erlang",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./erlang-D3aAYntO.js")
  ],
  [
    "excel",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./excel-CVx-mIB3.js")
  ],
  [
    "fix",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./fix-CXakTrmF.js")
  ],
  [
    "flix",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./flix-u_on4pRm.js")
  ],
  [
    "fortran",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./fortran-BmjCqiM6.js")
    )
  ],
  [
    "fsharp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./fsharp-CDimvotY.js")
  ],
  [
    "gams",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./gams-DuEmP1zu.js")
  ],
  [
    "gauss",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./gauss-ChHHGCTe.js")
  ],
  [
    "gcode",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./gcode-GDoPhwn7.js")
  ],
  ["genexus", () => import("./genexus-lang-CdFC67x3.js")],
  [
    "gherkin",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./gherkin-BG7f9qNH.js")
    )
  ],
  [
    "glsl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./glsl-DdvUF3Wz.js")
  ],
  [
    "gml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./gml-BDKc2vVr.js")
  ],
  [
    "go",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./go-Tv5clXZW.js")
  ],
  [
    "golo",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./golo-DrI9WnkO.js")
  ],
  [
    "gradle",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./gradle-Bx6z5vme.js")
  ],
  [
    "graphql",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./graphql-CHx1gYw6.js")
    )
  ],
  [
    "groovy",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./groovy-DmeKszN5.js")
  ],
  [
    "haml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./haml-CrjUkNSy.js")
  ],
  [
    "handlebars",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./handlebars-C0DnUwPz.js")
    )
  ],
  [
    "haskell",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./haskell-0EwB5sbC.js")
    )
  ],
  [
    "haxe",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./haxe-B52hycKv.js")
  ],
  [
    "hsp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./hsp-CHBuYu56.js")
  ],
  [
    "http",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./http-DKeNlJKS.js")
  ],
  [
    "hy",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./hy-iltgdZpt.js")
  ],
  [
    "inform7",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./inform7-Bw0pxW23.js")
    )
  ],
  [
    "ini",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ini-DooE8omt.js")
  ],
  [
    "irpf90",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./irpf90-jzFu2MPi.js")
  ],
  [
    "isbl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./isbl-bQ2bRwC5.js")
  ],
  [
    "java",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./java-KmhFI1Aw.js")
  ],
  [
    "javascript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./javascript-CDslspYb.js")
    )
  ],
  [
    "jboss-cli",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./jboss-cli-p3PJ_xZF.js")
    )
  ],
  [
    "json",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./json-bQdQrGhb.js")
  ],
  [
    "julia-repl",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./julia-repl-CrXbOR0j.js")
    )
  ],
  [
    "julia",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./julia-D_1kxIX3.js")
  ],
  [
    "kotlin",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./kotlin-BwB8b-YX.js")
  ],
  [
    "lasso",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./lasso-u6TBnIhS.js")
  ],
  [
    "latex",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./latex-Ck4GBbOP.js")
  ],
  [
    "ldif",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ldif-DYzlxuJW.js")
  ],
  [
    "leaf",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./leaf-pPRbLz7J.js")
  ],
  [
    "less",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./less-CreaU-Wa.js")
  ],
  [
    "lisp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./lisp-CVXfiVRT.js")
  ],
  [
    "livecodeserver",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./livecodeserver-BNx40oGo.js")
    )
  ],
  [
    "livescript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./livescript-3Fw2Rl3D.js")
    )
  ],
  [
    "llvm",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./llvm-BgMFSAwt.js")
  ],
  [
    "lsl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./lsl-xMGWIJie.js")
  ],
  [
    "lua",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./lua-DQl9S5bH.js")
  ],
  [
    "makefile",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./makefile-BjHEfe2p.js")
    )
  ],
  [
    "markdown",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./markdown-DX007chA.js")
    )
  ],
  [
    "mathematica",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./mathematica-Cb4glbk4.js")
    )
  ],
  [
    "matlab",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./matlab-2F_UsreO.js")
  ],
  [
    "maxima",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./maxima-14NG6KyU.js")
  ],
  [
    "mel",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./mel-B-pTSG4n.js")
  ],
  [
    "mercury",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./mercury-B2s8O0XL.js")
    )
  ],
  [
    "mipsasm",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./mipsasm-BeNKk5L1.js")
    )
  ],
  [
    "mizar",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./mizar-CHW3wQYB.js")
  ],
  [
    "mojolicious",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./mojolicious-CNjkOVyi.js")
    )
  ],
  [
    "monkey",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./monkey-BXVVFHPO.js")
  ],
  [
    "moonscript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./moonscript-DK44i7u0.js")
    )
  ],
  [
    "n1ql",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./n1ql-C64I-0o5.js")
  ],
  [
    "nestedtext",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./nestedtext-DzovkMhR.js")
    )
  ],
  [
    "nginx",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./nginx-CoDRjwVC.js")
  ],
  [
    "nim",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./nim-C33BoR1q.js")
  ],
  [
    "nix",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./nix-D0pHZP9z.js")
  ],
  [
    "node-repl",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./node-repl-VvXOdhrk.js")
    )
  ],
  [
    "nsis",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./nsis-BzxdIq3F.js")
  ],
  [
    "objectivec",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./objectivec-CnyrJ13Z.js")
    )
  ],
  [
    "ocaml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ocaml-T8IqWCjo.js")
  ],
  [
    "openscad",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./openscad-DvavoLEj.js")
    )
  ],
  [
    "oxygene",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./oxygene-ldhMlea1.js")
    )
  ],
  [
    "parser3",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./parser3-CDFud5Tp.js")
    )
  ],
  [
    "perl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./perl-Bz_rOmIg.js")
  ],
  [
    "pf",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./pf-DRFm3Dtf.js")
  ],
  [
    "pgsql",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./pgsql-TuTBQqxB.js")
  ],
  [
    "php-template",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./php-template-Cb4nAt7v.js")
    )
  ],
  [
    "php",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./php-okrj-mIS.js")
  ],
  [
    "plaintext",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./plaintext-CJCuRMbR.js")
    )
  ],
  [
    "pony",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./pony-CjLzB5jf.js")
  ],
  [
    "powershell",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./powershell-DuhUKWoO.js")
    )
  ],
  [
    "processing",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./processing-DiDcxJ81.js")
    )
  ],
  [
    "profile",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./profile-CLWy5xLz.js")
    )
  ],
  [
    "prolog",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./prolog-Di2AP0U2.js")
  ],
  [
    "properties",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./properties-DgS9to6H.js")
    )
  ],
  [
    "protobuf",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./protobuf-Cjwp7Mvb.js")
    )
  ],
  [
    "puppet",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./puppet-eXJ9NxBB.js")
  ],
  [
    "purebasic",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./purebasic-CJ8seXww.js")
    )
  ],
  [
    "python-repl",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./python-repl-CH4WSSF4.js")
    )
  ],
  [
    "python",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./python-CzH_tl5q.js")
  ],
  // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
  ["q", async () => import("./q-BjbNrvjI.js")],
  [
    "qml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./qml-DRzowo7i.js")
  ],
  // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
  ["r", async () => import("./r-B8fCBydS.js")],
  [
    "reasonml",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./reasonml-CX8adqOK.js")
    )
  ],
  [
    "rib",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./rib-D4vMDx6e.js")
  ],
  [
    "roboconf",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./roboconf-Jp-6zDnX.js")
    )
  ],
  [
    "routeros",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./routeros-CzUg5PCE.js")
    )
  ],
  [
    "rsl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./rsl-wfxRySQa.js")
  ],
  [
    "ruby",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./ruby-yRawv3bF.js")
  ],
  [
    "ruleslanguage",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./ruleslanguage-GQ_T_tpY.js")
    )
  ],
  [
    "rust",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./rust-Df3z6Pf8.js")
  ],
  [
    "sas",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./sas-j38pIcD9.js")
  ],
  [
    "scala",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./scala-Fkc9hhiK.js")
  ],
  [
    "scheme",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./scheme-YM-gQodR.js")
  ],
  [
    "scilab",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./scilab-UJwveiu_.js")
  ],
  [
    "scss",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./scss-CxPYwcy0.js")
  ],
  [
    "shell",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./shell-DYrX6oL5.js")
  ],
  [
    "smali",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./smali-Bg2gPljl.js")
  ],
  [
    "smalltalk",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./smalltalk-Cilklw6a.js")
    )
  ],
  [
    "sml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./sml-DET0cBoT.js")
  ],
  [
    "sqf",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./sqf-CdtSGdGH.js")
  ],
  [
    "sql",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./sql-C4aKMNLK.js")
  ],
  [
    "stan",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./stan-Cc9sLMZf.js")
  ],
  [
    "stata",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./stata-CBohThMJ.js")
  ],
  [
    "step21",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./step21-D6QYPsCc.js")
  ],
  [
    "stylus",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./stylus-BX3mQXRC.js")
  ],
  [
    "subunit",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./subunit-NrV4TEs6.js")
    )
  ],
  [
    "swift",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./swift-QjAByuob.js")
  ],
  [
    "taggerscript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./taggerscript-DRXy4b7O.js")
    )
  ],
  [
    "tap",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./tap-Bgaco9fV.js")
  ],
  [
    "tcl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./tcl-DovJkxCP.js")
  ],
  [
    "thrift",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./thrift-Df99YBCw.js")
  ],
  [
    "tp",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./tp-C5am3nMo.js")
  ],
  [
    "twig",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./twig-DJZWM29X.js")
  ],
  [
    "typescript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./typescript-Bx5cZccb.js")
    )
  ],
  [
    "vala",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./vala-6SdCQzFC.js")
  ],
  [
    "vbnet",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./vbnet-D7PCGZRn.js")
  ],
  [
    "vbscript-html",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./vbscript-html-uUhcglDb.js")
    )
  ],
  [
    "vbscript",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./vbscript-Cai76bUf.js")
    )
  ],
  [
    "verilog",
    async () => (
      // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
      import("./verilog-Bhmrj6SN.js")
    )
  ],
  [
    "vhdl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./vhdl-GvQ2nGmD.js")
  ],
  [
    "vim",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./vim-CDm39-gm.js")
  ],
  [
    "wasm",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./wasm-7k2agMew.js")
  ],
  [
    "wren",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./wren-Rq2lVKy5.js")
  ],
  [
    "x86asm",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./x86asm-CWMasPdD.js")
  ],
  [
    "xl",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./xl-CP_J5mCA.js")
  ],
  [
    "xml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./xml-B7THKYqr.js")
  ],
  [
    "xquery",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./xquery-DjRYiL7r.js")
  ],
  [
    "yaml",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./yaml-r1h_vUPe.js")
  ],
  [
    "zephir",
    // @ts-expect-error The module exists but it is not marked as exported in the highlight.js' package.json
    async () => import("./zephir-D0FmFd69.js")
  ]
]), tn = {
  apacheconf: "apache",
  arm: "armasm",
  mawk: "awk",
  nawk: "awk",
  gawk: "awk",
  sh: "bash",
  zsh: "bash",
  clj: "clojure",
  cs: "csharp",
  docker: "dockerfile",
  bat: "dos",
  cmd: "dos",
  golang: "go",
  h: "c",
  hpp: "cpp",
  cc: "cpp",
  hh: "cpp",
  "c++": "cpp",
  "h++": "cpp",
  cxx: "cpp",
  hxx: "cpp",
  hs: "haskell",
  gx: "genexus",
  GeneXus: "genexus",
  Genexus: "genexus",
  geneXus: "genexus",
  jsp: "java",
  react: "javascript",
  js: "javascript",
  jsx: "javascript",
  mk: "makefile",
  mak: "makefile",
  make: "makefile",
  md: "markdown",
  mkdown: "markdown",
  mkd: "markdown",
  py: "python",
  gyp: "python",
  rb: "ruby",
  gemspec: "ruby",
  podspec: "ruby",
  thor: "ruby",
  irb: "ruby",
  rs: "rust",
  txt: "plaintext",
  text: "plaintext",
  ts: "typescript",
  tsx: "typescript",
  mts: "typescript",
  cts: "typescript",
  vb: "vbnet",
  vbs: "vbscript",
  yml: "yaml",
  html: "xml",
  xhtml: "xml",
  rss: "xml",
  atom: "xml",
  xjb: "xml",
  xsd: "xml",
  xsl: "xml",
  plist: "xml",
  svg: "xml"
}, le = Qt();
let V;
const rn = (y, h) => le.highlight(y, h), cn = (y, h) => le.register({ [y]: h }), on = (y) => tn[y] ?? y, nn = (y) => (y === "javascript" || y === "typescript") && !V.has("xml"), an = async (y) => {
  V ?? (V = /* @__PURE__ */ new Set());
  const h = _e.get(y) ?? _e.get("plaintext");
  if (!(V.has(y) || !h))
    if (nn(y)) {
      const S = _e.get("xml"), E = await Promise.allSettled([
        h(),
        S()
      ]);
      le.register({
        [y]: E[0].value.default,
        xml: E[1].value.default
      }), V.add(y), V.add("xml");
    } else {
      const S = (await h()).default;
      le.register({ [y]: S }), V.add(y);
    }
};
export {
  on as getActualLanguageWithoutAlias,
  rn as parseCodeToHAST,
  cn as register,
  an as registerLanguage
};
